<ng-container *ngIf="vm$ | async as vm">
	<ui-content-header type="page" title="Verify Instructions Routing">
		<div actions class="flex gap-2 items-center">
			<ui-button preset="ICON_DEFAULT" icon="x" (click)="close()"></ui-button>
		</div>
	</ui-content-header>
	<ng-container *ngIf="vm.stepHistory.at(-1) as currentStep">
		<div
			[ngSwitch]="currentStep.stepName"
			class="flex flex-col gap-6 h-full justify-between"
		>
			<section
				*ngSwitchCase="DisconnectFromAssystSteps.LSO_FAX_DETECTED"
				class="flex flex-col gap-6"
			>
				<h3>Confirm Your LSO Fax Number</h3>
				<p class="p-sm">
					Make sure this is accurate! To receive your mortgage instructions,
					lenders will need to send them to you via the fax number affiliated
					with your LSO account.
				</p>
				<ui-note title="LSO Fax Detected">
					<p class="p-sm">
						We’ve found a fax number associated with your LSO account! Confirm
						the details below are correct.
					</p>
				</ui-note>
				<div class="w-2/3 gap-6 flex flex-col self-center">
					<img
						src="/assets/images/lso-logo.png"
						alt="Logo of the Law Society of Ontario"
					/>

					<dl
						class="flex flex-col gap-1 items-center border border-solid border-teal-200 bg-teal-100 rounded-lg py-6"
					>
						<dt class="text-base">Fax Number</dt>
						<dd class="text-xl">{{ vm.lsoFaxNumber }}</dd>
					</dl>
				</div>
				<p>Confirm LSO Fax:</p>
				<app-radio-group
					type="clear"
					name="lsoFaxNumberConfirmed"
					orientation="vertical"
					alignContents="left"
					[items]="numberConfirmedRadioOptions"
					[(ngModel)]="vm.isFaxNumberConfirmed"
				></app-radio-group>
				<ui-note
					title="Update your LSO Profile"
					type="warning"
					*ngIf="vm.isFaxNumberConfirmed === false"
					callToActionType="EXTERNAL"
					callToActionUrl="https://lso.ca/public-resources/finding-a-lawyer-or-paralegal/lawyer-and-paralegal-directory"
					callToActionLabel="Go to LSO Directory"
				>
					<p class="p-sm">
						Use the link above to access your online LSO Profile and submit a
						change request to update your fax number. After completing your
						change request, select Next to continue.
					</p>
				</ui-note>
			</section>

			<section
				*ngSwitchCase="DisconnectFromAssystSteps.LSO_FAX_NOT_DETECTED"
				class="flex flex-col gap-6"
			>
				<img
					class="flex self-center w-1/3"
					src="/assets/images/undraw_void_re.png"
					alt="A man staring into the void"
				/>
				<ui-note
					title="Fax Number Not Detected"
					type="error"
					callToActionType="EXTERNAL"
					callToActionUrl="https://lso.ca/public-resources/finding-a-lawyer-or-paralegal/lawyer-and-paralegal-directory"
					callToActionLabel="Go to LSO Directory"
				>
					<p class="p-sm">
						We couldn’t find a fax number associated with your LSO account! In
						order to receive instructions from Sync-supported lenders, you must
						have a fax number affiliated with your LSO account.
					</p>
					<p class="p-sm">
						Use the link above to access your online LSO Profile and submit a
						change request to update your fax number. After completing your
						change request, select Next to continue.
					</p>
				</ui-note>
				<h3 class="capitalize">Do you have an active fax service?</h3>
				<app-radio-group
					type="clear"
					name="lsoFaxNumberUpdated"
					orientation="vertical"
					alignContents="left"
					[items]="faxNumberUpdatedRadioOptions"
					[(ngModel)]="vm.isFaxNumberConfirmed"
					class="capitalize"
				></app-radio-group>
				<ui-note
					title="Update Your LSO Profile"
					*ngIf="vm.isFaxNumberConfirmed"
					callToActionType="EXTERNAL"
					callToActionUrl="https://lso.ca/public-resources/finding-a-lawyer-or-paralegal/lawyer-and-paralegal-directory"
					callToActionLabel="Go to LSO Directory"
				>
					<p class="p-sm">
						Access your online LSO Profile and submit a change request to update
						your fax number. After completing your change request, select Next
						to continue.
					</p>
				</ui-note>

				<ui-note
					title="An active fax is required"
					type="warning"
					*ngIf="vm.isFaxNumberConfirmed === false"
					callToActionType="EXTERNAL"
					callToActionUrl="https://www.lawlabs.ca/sync-by-closer"
					callToActionLabel="Talk to Our Staff"
				>
					<p class="p-sm">
						In order to receive instructions from Sync-supported lenders fax
						services to your personal LSO fax number must be set up. Connect
						with our sales team using the link above to explore recommended
						digital fax services.
					</p>
				</ui-note>
				<!-- 
                <app-checkbox *ngIf="vm.isFaxNumberConfirmed" type="clear" [(ngModel)]="vm.hasFaxNumberBeenUpdated"
                    label="I have successfully updated my LSO fax information."></app-checkbox> -->
			</section>

			<section
				*ngSwitchCase="DisconnectFromAssystSteps.FAX_OR_ASSYST"
				class="flex flex-col gap-6"
			>
				<h3>Route Instructions to your Fax Number</h3>
				<p class="p-sm">
					Lastly, let’s make sure you’re set up to receive instructions from
					Sync-supported lenders. To help us guide you, please confirm how you
					currently receive instructions from the following lenders.
				</p>
				<div
					class="rounded-lg border grid grid-cols-2 grid-rows-5 gap-x-6 gap-y-2 py-6 px-4"
				>
					<div
						class="flex items-center border rounded-lg justify-between gap-6 px-4 py-2"
						*ngFor="let lender of closerSyncLenders"
					>
						<div>
							<img
								class="max-w-[80px]"
								src="assets/images/banks/{{ lender.imgUrl }}"
							/>
						</div>
						<div class="flex-1">{{ lender.label }}</div>
					</div>
				</div>

				<p class="text-sm font-bold">
					How are you currently receiving your instructions from these lenders?
				</p>
				<app-radio-group
					type="clear"
					alignContents="left"
					name="currentInstructionCommunication"
					orientation="vertical"
					[items]="instructionRoutingOptions"
					[(ngModel)]="vm.instructionRouting"
				></app-radio-group>
			</section>

			<section
				class="flex flex-col gap-6"
				*ngSwitchCase="DisconnectFromAssystSteps.DISCONNECT_FROM_ASSYST"
			>
				<h3>Disconnect from Lender Centre</h3>
				<p class="p-sm">
					To use Sync by Closer, you'll need to re-route your instructions to be
					sent to the fax number listed on your LSO profile. Please email
					<a
						emailLinkInterceptor
						[href]="mailTo"
						class="underline hover:text-green-300"
						>UnityLCAdmin&#64;DyeDurham.com</a
					>
					and send a request for the following:
				</p>
				<ol class="flex flex-col gap-2">
					<li class="list-decimal list-inside">
						Your Lender Centre profile be put into pending deactivation until
						all active files are completed.
					</li>
					<li class="list-decimal list-inside">
						The account be kept active for the purpose of mortgage discharge
						requests.
					</li>
				</ol>
				<p class="p-sm">
					After deactivating your Lender Centre profile, lenders will begin
					faxing your instructions to your LSO fax number. For updates and
					inquiries on your Lender Centre profile deactivation, please contact:
					1-877-418-7511.
				</p>
				<ui-note
					title="You will no Longer Receive Mortgages from Lender Centre"
					type="warning"
				>
					<p class="p-sm">
						You will be able to access it for the purpose of mortgage discharge
						requests. Please note that the email request will need to be sent
						from your lawyer email directly for consent purposes.
					</p>
				</ui-note>
				<app-container>
					<div class="flex flex-col gap-4 pt-2 pb-1">
						<h4>Sample Email Script</h4>
						<p class="p-sm">
							Here is some sample scripting you can use when emailing to
							deactivate your profile:
						</p>
						<p class="p-sm">”{{ emailBody }}”</p>
						<div class="flex items-center gap-2">
							<ui-anchor target="_blank" class="flex" [href]="mailTo"
								>Send Email</ui-anchor
							>
							<ui-button
								preset="LOW_EMPHASIS"
								icon="clipboard-copy"
								label="Copy"
								(click)="copyToClipboard()"
							/>
						</div>
					</div>
				</app-container>

				<app-checkbox
					type="clear"
					[(ngModel)]="vm.isAssystDisconnected"
					label="I have successfully discontinued the use of Lender Centre."
				></app-checkbox>
			</section>

			<section
				*ngSwitchCase="DisconnectFromAssystSteps.ALL_SET_FAX"
				class="flex flex-col gap-4"
			>
				<img
					class="w-[215px] h-[200px] mx-auto mt-6"
					src="/assets/images/undraw_file_manager_re.svg"
					alt="Woman reaching out for pages hanging from abstract art"
				/>

				<div class="mt-6">
					<p class="mb-2 text-lg font-medium">
						Are you currently receiving instructions to your LSO Fax Number?
					</p>
					<p class="p-sm leading-6 mb-8">
						To integrate with Sync, you must be receiving your mortgage
						instructions from RBC, BMO, CIBIC, Nesto, Alterna, Meridian, Motus,
						Simplii, Libro, and National Bank to your LSO fax number.
					</p>

					<ui-note
						title="Receiving Instructions From Lender Centre?"
						type="warning"
						class="mt-4"
					>
						<p class="p-sm">
							If you are receiving mortgage instructions from RBC, BMO, CIBC,
							Nesto, Alterna, Meridian, Motus, Simplii, Libro, and National Bank
							through Lender Centre, you need to disconnect from Lender Centre
							before proceeding.
						</p>
						<app-anchor type="static" (click)="goToLearnMore()"
							>Learn More</app-anchor
						>
					</ui-note>
				</div>
			</section>

			<section
				*ngSwitchCase="DisconnectFromAssystSteps.ALL_SET_ASSYST"
				class="flex flex-col gap-4"
			>
				<div class="flex justify-center items-center flex-col mt-10">
					<div class="flex flex-col text-center">
						<app-icon
							class="text-6xl text-green"
							[icon]="ICON.CIRCLE_CHECK"
						></app-icon>
						<p class="pt-1">Connected</p>
					</div>

					<p class="my-10 font-bold text-xl">
						You have successfully integrated with Sync!
					</p>
				</div>

				<hr class="my-4" />

				<div class="mt-4">
					<p class="mb-4 text-base font-bold">
						Upload Mortgage Instructions In Closer:
					</p>
					<p class="p-sm font-normal leading-6">
						After recieving the faxed instructions, you can proceed to digitize
						your mortgage instructions.
						<app-anchor
							class="inline-block"
							type="static"
							(click)="goToTheMortgageInbox()"
							>Go to the mortgage inbox
						</app-anchor>
						and select 'upload instructions'. Once uploaded, the instructions
						will show up in your mortgage inbox within 15 minutes, ready for you
						to assign to a file.
					</p>
					<img
						class="mx-auto mt-2 w-[250px] h-[220px]"
						src="/assets/images/mortgage/sync-sign-up-success-state.svg"
					/>
				</div>
			</section>

			<footer
				class="sticky pr-8 pl-4 py-4 bottom-0 bg-white border-t border-grey-lighter flex justify-between items-center gap-2"
			>
				<div>
					<app-checkbox
						type="clear"
						*ngIf="showFaxNumberConfirmation"
						[ngModel]="vm.hasFaxNumberBeenUpdated"
						(ngModelChange)="updateHasFaxNumberBeenUpdated($event)"
					>
						I have updated the fax number on my LSO profile
					</app-checkbox>
				</div>
				<div class="flex gap-2 items-center">
					<ui-button
						color="gray"
						*ngIf="currentStep.backActionText"
						label="{{ currentStep.backActionText }}"
						preset="LOW_EMPHASIS"
						(click)="currentStep.backAction()"
					/>
					<ui-button
						label="{{ currentStep.nextActionText }}"
						[disabled]="isNextActionDisabled"
						[loading]="vm.isLoading"
						(click)="currentStep.nextAction()"
					/>
				</div>
			</footer>
		</div>
	</ng-container>
</ng-container>
